import React, { useEffect, useState } from 'react';
import { AuthGate, AuthServiceProvider, fetchConfig } from '@trp-ta-nitro/auth-react';
import { loggedInMGPURLs } from '../components/shared/Links';
import { Container } from '@mui/material';
import { matchPathname } from '../Utils';
import Loading from './Loading';
import App from '../components/App';
import AnonymousUserContainer from './AnonymousUserContainer';

// Loader on page until auth is verified
const LoadingWrapper = () => (
    <Container maxWidth="xl">
        <Loading />
    </Container>
);

const AuthContainer = () => {
    const [isLoading, setLoading] = useState(true);
    const [options, setOptions] = useState({ requireAuthentication: !!matchPathname(loggedInMGPURLs).length })

    useEffect(() => {
        fetchConfig([`${window.location.origin}/usis/advice/tools/retirement-income-calculator/api-config.json`])
        .then(response => {
            setOptions({ ...response, requireAuthentication: !!matchPathname(loggedInMGPURLs).length });
            setLoading(false);
        })
        .catch(err => {
            setLoading(false);
            throw(err);
        });
    }, [])
    
    const ConfiguredAndAuthenticatedApp = () => {
        return <div><App applicationConfig={options} /></div>;
    };

    if (window.location.origin === 'https://www.troweprice.com') {
        console.log = function () {};
    }

    return isLoading ? <LoadingWrapper /> : 
        <AuthServiceProvider options={options}>
            <AuthGate 
                loading={LoadingWrapper} 
                unauthenticated={window.location.pathname.includes('secure') ? '' : () => <AnonymousUserContainer applicationConfig={options} />}
            >
                <ConfiguredAndAuthenticatedApp />
            </AuthGate>
        </AuthServiceProvider>
}

export default AuthContainer;
